import { withInstall } from '@zoryn/utils'
import Tooltip from './src/tooltip.vue'

import type { SFCWithInstall } from '@zoryn/utils'

export const ZTooltip: SFCWithInstall<typeof Tooltip> = withInstall(Tooltip)
export * from './src/tooltip'
export * from './src/trigger'
export * from './src/content'
export * from './src/constants'
export default ZTooltip
